<template>
  <div>
    <Modal class="modal-point" :visible="visible" @cancel="handleClose" :size="size">
      <UseBenepoint :visible="visible" :useCafe="useCafe" @ok="handleOk" @close="handleClose" :keyboard="false"/>
    </Modal>
  </div>
</template>

<script>
import _ from 'lodash'
import UseBenepoint from '../UseBenepoint'

export default {
  name: 'UseBenepointPopup',
  components: {
    UseBenepoint
  },
  props: ['visible', 'size', 'useCafe'],
  data() {
    return {
      planDetail: null,
      stayDay: null,
      stayNights: null,
      stayRooms: null,
      vacancyCalendar: null,
      couponPlanData: null,
      couponVerified: undefined
    }
  },
  mounted() {
    if (this.statePlanDetail) {
      this.planDetail = _.cloneDeep(this.statePlanDetail)
    }
    if (this.stateCustomerPlan) {
      this.stayDay = this.stateCustomerPlan.stayDay
      this.stayNights = this.stateCustomerPlan.stayNights
      this.stayRooms = this.stateCustomerPlan.stayRooms
      this.vacancyCalendar = this.stateCustomerPlan.vacancyCalendar
      this.couponPlanData = {
        memberAdults: this.stateCustomerPlan.memberAdults,
        visitorAdults: this.stateCustomerPlan.visitorAdults,
        memberChldDetails: this.stateCustomerPlan.memberChldDetails,
        visitorChldDetails: this.stateCustomerPlan.visitorChldDetails
      }
    }
  },
  computed: {
    statePlanDetail() {
      return this.$store.getters.planDetail
    },
    stateCustomerPlan() {
      return this.$store.getters.customerPlan
    },
    bsAppState() {
      return this.$store.getters.bs_app
    }
  },
  methods: {
    onChangeCouponPlan($event) {
      this.couponPlanData = $event
    },
    handleOk($event) {
      this.$emit('ok', $event)
    },
    handleClose() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="css">
  .coupon-popup-footer {
    @apply flex justify-end gap-x-2;
  }
</style>
